var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{ref:"textarea",staticClass:"form-input rounded-md shadow-sm",class:_vm.className || '',attrs:{"placeholder":_vm.placeholder},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}},[_vm._v(_vm._s(_vm.value))])
}
var staticRenderFns = []

export { render, staticRenderFns }